export const config = {
    name: 'repaymentPlan',
    searchFields: [
        {
            name: '分公司',
            value: 'companyName',
            type: 'advanceMulti',
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'companyName', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyName', 'value': '分公司名称', 'displayName': 'companyName' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/company/manager/archive/companyPage`,
            method: 'post',
            cbParams: ['companyName', 'companyCode']
        },
        {
            name: '行业大类',
            value: 'industryCategoriesCodeList',
            type: 'select',
            options: [],
            isFixed: true,
            multiple: true,
            span: 4
        },
        {
            name: '细分等级',
            value: 'customerLevelCodeList',
            type: 'select',
            options: [],
            // optionNum: 'NEOCRM_CUSTOMER_LEVEL',
            isFixed: true,
            multiple: true,
            span: 4
        },
        {
            name: '跟进终止日期',
            toolitpName: '提前终止时间、提前续签/延期时间、合同失效日期',
            value: 'followupExpiryDate',
            type: 'time',
            time: true,
            startPlaceholder: '跟进终止日期从',
            endPlaceholder: '跟进终止日期到',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            isFixed: true,
            span: 6
        },
        {
            name: '续签状态',
            value: 'renewalStatusList',
            type: 'select',
            // optionNum: 'CRM_CONTRACT_RENEWAL_STATUS',
            options: [],
            isFixed: true,
            multiple: true,
            span: 4
        },
        {
            name: '待办跟进人',
            value: 'renewalContractors',
            type: 'advanceMulti',
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusId', 'value': 'ID' }
            ],
            tableConfig: [
                { 'prop': 'esusId', 'value': 'ID' },
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名', 'displayName': 'esusUserNameCn' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#renewalContractor', 'esusLoginName#renewalContractorMip'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            }
        },
        {
            name: '合同状态',
            value: 'contractStatusList',
            isFixed: true,
            multiple: true,
            // optionNum: 'SYS_CR_CONTRACT_STATUS',
            type: 'select',
            options: [
                { value: '2', label: '有效' },
                { value: '4', label: '终止' },
                { value: '5', label: '失效' },
                { value: '7', label: '合同废弃' }
            ],
            span: 3
        },
        {
            name: '合同性质',
            value: 'contractCharacterList',
            optionNum: 'SYS_WM_CONTRACT_CHARACTER',
            type: 'select',
            span: 3,
            multiple: true,
            isFixed: true
        },
        {
            name: '续签风险',
            value: 'renewalRiskList',
            // optionNum: 'CRM_CONTRACT_RENEWAL_RISK',
            options: [],
            type: 'select',
            span: 3,
            isFixed: true,
            multiple: true
        }
    ],
    selection: false,
    index: false,
    height: '500px',
    industryColumns: [
        {
            label: '行业名称',
            prop: 'industryCategoriesName'
        },
        {
            label: '风险预判未完成（M+3）',
            type: 'slot',
            prop: 'riskAssessmentIncomplete',
            sort: true
        },
        {
            label: '最终结果未确认（当月）',
            type: 'slot',
            sort: true,
            prop: 'finalResultUnconfirmed'
        },
        {
            label: '待完成总数',
            type: 'slot',
            sort: true,
            prop: 'incompleteTotal'
        },
        {
            label: '已完成',
            type: 'slot',
            sort: true,
            prop: 'completed'
        },
        {
            label: '待办总数量',
            type: 'slot',
            sort: true,
            prop: 'totalTodos'
        },
        {
            label: '完成率',
            prop: 'completionRateStr'
        }
    ],
    companyColumns: [
        {
            label: '分公司名称',
            prop: 'companyName'
        },
        {
            label: '风险预判未完成（M+3）',
            type: 'slot',
            sort: true,
            prop: 'riskAssessmentIncomplete'
        },
        {
            label: '最终结果未确认（当月）',
            type: 'slot',
            sort: true,
            prop: 'finalResultUnconfirmed'
        },
        {
            label: '待完成总数',
            type: 'slot',
            sort: true,
            prop: 'incompleteTotal'
        },
        {
            label: '已完成',
            type: 'slot',
            sort: true,
            prop: 'completed'
        },
        {
            label: '待办总数量',
            type: 'slot',
            sort: true,
            prop: 'totalTodos'
        },
        {
            label: '完成率',
            prop: 'completionRateStr'
        }
    ],
    personalColumns: [
        {
            label: '用户姓名',
            prop: 'handlerName'
        },
        {
            label: '用户MIP',
            prop: 'handlerCode'
        },
        {
            label: '部门',
            prop: 'department'
        },
        {
            label: '上级经理',
            prop: 'manager'
        },
        {
            label: '风险预判未完成（M+3）',
            type: 'slot',
            sort: true,
            prop: 'riskAssessmentIncomplete'
        },
        {
            label: '最终结果未确认（当月）',
            type: 'slot',
            sort: true,
            prop: 'finalResultUnconfirmed'
        },
        {
            label: '待完成总数',
            type: 'slot',
            sort: true,
            prop: 'incompleteTotal'
        },
        {
            label: '已完成',
            type: 'slot',
            sort: true,
            prop: 'completed'
        },
        {
            label: '已编辑任务数量',
            type: 'slot',
            sort: true,
            prop: 'editedTaskCount'
        },
        {
            label: '全部任务数量',
            type: 'slot',
            sort: true,
            prop: 'totalTaskCount'
        }
    ],
    titleTips: `一、状态定义
风险预判未完成：针对续签登记待办，若「续签风险」「续签状态」「风险原因」三个关键字段中，任意一个字段为空值，即判定为该状态。
最终结果未确认：续签状态不属于「已续签」「已终止」，且该待办的跟进月份为当前月份。
已完成：排除上述两种状态的所有续签登记待办，即风险预判字段齐全、且续签状态为明确结果（已续签/已终止）待办，以及续签状态不属于「已续签」「已终止」，且该待办的跟进月份不是当前月份的待办。

二、未完成率计算口径
风险预判未完成率 = 风险预判未完成待办数量 ÷ 全量续签登记待办总数量（分子分母均为去重后数据）
最终结果未确认率 = 最终结果未确认待办数量 ÷ 全量续签登记待办总数量（分子分母均为去重后数据）

三、统计口径说明
合计：统计系统内全量续签登记待办及各状态分布数据，对同一待办在不同状态间严格去重，确保单条待办仅在对应状态下计数一次，无重复统计。
行业：单条续签合同登记可关联多个行业，统计时按关联关系拆分计数，每条待办关联几个行业，就分别在对应行业维度各统计一次该条待办。
分公司：单条续签合同登记仅归属唯一一家分公司，无多归属情况，统计时按待办所属分公司单次计数，精准对应分公司主体。
个人：以待办承接人为统计维度，逐一统计每个承接人名下，上述三种状态各自的待办数量，清晰呈现个人待办任务分布。
    `
};
